import { EmptyState } from '../../../components/common/EmptyState';
import { ChatCircleText, MagnifyingGlass, Tag, UsersThree, type Icon } from '../../../design-system/icons';
import type { OutreachCrmView } from '../../search';

const VIEW_EMPTY: Record<OutreachCrmView, { icon: Icon; title: string; body: string }> = {
  all: {
    icon: UsersThree,
    title: 'No creators in outreach yet',
    body: 'Add creators from the Inbox and they show here.',
  },
  conversations: {
    icon: ChatCircleText,
    title: 'No conversations yet',
    body: 'Creators show here once an email goes out or a reply comes in.',
  },
  rates: {
    icon: Tag,
    title: 'No rates yet',
    body: 'Creators show here once they quote a rate or one is locked.',
  },
};

export const NO_RESULTS_TITLE = 'No results';
export const CLEAR_SEARCH_LABEL = 'Clear search';

interface CrmListEmptyProps {
  view: OutreachCrmView;
  query: string;
  onClearSearch: () => void;
}

/** A search that matched nothing offers to clear it; otherwise each list explains what will fill it. */
export function CrmListEmpty({ view, query, onClearSearch }: CrmListEmptyProps) {
  if (query) {
    return (
      <EmptyState
        icon={MagnifyingGlass}
        title={NO_RESULTS_TITLE}
        body={`No creators match “${query}”.`}
        action={{ label: CLEAR_SEARCH_LABEL, onClick: onClearSearch }}
      />
    );
  }
  const copy = VIEW_EMPTY[view];
  return <EmptyState icon={copy.icon} title={copy.title} body={copy.body} />;
}
